import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useForm } from 'react-hook-form';

import Filter from './filter'
import Map from './map'
import List from '../map/list'
import Teaser from './teaser'

import { calculateState } from '../../utils'
import { deburr } from 'lodash'




const CrownPastoralLandSnapshotApp = ({ endpoint, settings, noResultsText, defaultCentre, defaultZoom }) => {

  const { register, handleSubmit, resetField } = useForm();
  const [ filtered, setFiltered ] = useState(null);
  const [ hidden, setHidden ] = useState(false);
  const [ filters, setFilters ] = useState({
    keywords: '',
    district: '',
    stage: ''
  })

  const [ mapDefaults, setMapDefaults ] = useState({
    defaultCentre,
    defaultZoom
  })


    const { isLoading, error, data } = useQuery(`ppc`, async () => {
        return await fetch(endpoint, {
          headers: new Headers({
            'content-type': 'application/json'
          })
        }).then(async res => {
          if(res.ok) {
            return await res.json()
          }
          throw await res.json();
        }).then(items => {
          return items.filter(item => {
            if(!item.field_consultation_date_start) {
              return false
            }
            if(!item.field_consultation_date_end){
              return false
            }
            if(!item.field_geolocation) {
              return false;
            }
            return item;
          }).map(item => {
            const start = new Date(item.field_consultation_date_start);
            const end = new Date(item.field_consultation_date_end);

            return {
              ...item,
              field_region: item.field_region.replace('&#039;', '’'),
              latitude: parseFloat(item.field_geolocation.split(',')[0]),
              longitude: parseFloat(item.field_geolocation.split(',')[1]),
              start,
              end,
              status: calculateState(start, end)
            }
          })
        })
        .then(items => items.map(item => ({
          ...item,
          isCloseToAntimeridian: item.longitude < -175
        })))
      }
    )

    useEffect(() => {
      if(data && data.length) {
        setFiltered(data);
      }
    }, [data]);

    useEffect(() => {
      if(!data) {
        return;
      }
      
      let clone = [...data];
      if(filters?.keywords.length > 2) {
        // do filtering
        let keywords = deburr(filters.keywords).toLowerCase();
        clone = clone.filter(({ title }) => deburr(title).toLowerCase().includes(keywords.toLowerCase()))
        //clone = clone.filter(({ title }) => title.toLowerCase().includes(filters.keywords.toLowerCase()))
      }
      if(filters?.district.length > 0) {
        clone = clone.filter(({ field_region }) => field_region === filters.district)
      }
      if(filters?.stage) {
        clone = clone.filter(({ status }) => status === filters.stage)
      }


      setFiltered(clone);
    }, [filters]);


    if(isLoading) {
      return <div className="spinner">&nbsp;</div>;
    }

    if(data.length === 0) {
      return <div className="linz-map-snapshot__no-results">{noResultsText}</div>
    }


    const districts = [...new Set(data.map(({ field_region }) => field_region))].filter(item => item);
    const stages = [...new Set(data.map(({ status }) => status))].filter(item => item);


    const onFilter = ({ keywords, district, stage }) => {

      setFilters({
        keywords: keywords || '',
        district: district || '',
        stage: stage || ''
      });
    }


    const onReset = () => {
      setFiltered(data);
      resetField('keywords')
      resetField('district')
      resetField('stage')
      setFilters({
        keywords: '',
        district: '',
        stage: ''
      })
      setMapDefaults({
        defaultCentre,
        defaultZoom
      })
    }

    let role = filters.keywords !== '' || filters.district !== '' || filters.stage !== '' ? 'status' : '';

    return (

      <div data-show-results={hidden ? false : true} className="place-name-consultation-map__app map__app">
        <Filter
          id={`ppc`}
          districts={districts}
          stages={stages}
          register={register}
          handleSubmit={handleSubmit(onFilter)}
          onReset={onReset}
          filters={filters}
        />
        {filtered && (
          <div className="map__controls" role={role}>
            <h3>{`Showing ${filtered.length} location${filtered.length === 1 ? '' : 's'}`}</h3>
            {/*<button type="button" onClick={() => setHidden(!hidden)}>{hidden ? 'Show' : 'Hide'}</button>*/}
          </div>
        )}
        {filtered && <List data={filtered} Elem={Teaser} />}
          {filtered && mapDefaults && <Map data={filtered} {...mapDefaults} />}

      </div>
    )
}
export default CrownPastoralLandSnapshotApp
